import { apiGet, apiPatch } from './client';
import type { CalcType, CalcTypeBatchRequest } from '../types/CalcType';

export function getCalcTypes(): Promise<CalcType[]> {
  return apiGet<CalcType[]>('/api/calc-types');
}

export function saveCalcTypesBatch(
  added: CalcType[],
  modified: CalcType[],
  deletedIds: number[],
): Promise<CalcType[]> {
  return apiPatch<CalcTypeBatchRequest, CalcType[]>('/api/calc-types/batch', {
    added,
    modified,
    deleted: deletedIds,
  });
}
